import { useMutation } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';
import { API_VERSION, CLIENT_VERSION } from '../shared/config';

export function useFindSimulationBestOffer({ proposalId = '', token = '' }) {
  const mutation = useMutation({
    mutationKey: ['find-simulation-best-offer', proposalId, token],
    mutationFn: async () => {
      const data = await handleFetchResponse(
        fetch(getApiUrl(`energia-solar/v2/simulation/best-offer`), {
          headers: {
            'x-api-version': API_VERSION,
            'x-client-version': CLIENT_VERSION,
            Authorization: `Bearer ${token}`,
          },
        }),
      );
      return data;
    },
  });

  return mutation;
}
